var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.allLoaded
    ? _c(
        "section",
        { staticClass: "dashboard-container" },
        [
          _c("LfHeaderTitleComponent", {
            attrs: { title: _vm.$t("navigation.drawer-menu-items.home") },
          }),
          _vm.hasActionsPermission ? _c("DashboardActionsWidget") : _vm._e(),
          _c("DashboardCountersWidget"),
          _vm.hasAgendaPermission ? _c("LexboxCalendarComponent") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }